<template>
  <div v-if="dataHistory.length === 0" style="min-height: 50vh">
    <div class="columns is-centered">
      <div class="column has-text-centered">
        <ProyekEmptyIcon />
        <p class="averta-bold">Tidak Ada Riwayat Larangan Bekerja</p>
      </div>
    </div>
  </div>
  <div v-else class="wrap-history">
    <div class="card p-4">
      <div
        class="is-flex is-flex-direction-row is-justify-content-flex-center is-align-items-center c-w-100"
      >
        <!-- Content Table -->
        <div class="content-table-history">
          <div class="header-table-history">
            <div class="row-content-table-history">
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Tanggal Perubahan</p>
              </div>
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Nama Petugas</p>
              </div>
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Platform</p>
              </div>
              <div class="data-table-history-3">
                <p class="averta-bold label-14 color-white">Detail</p>
              </div>
            </div>
          </div>
          <div class="body-table-history">
            <div
              v-for="(history, indexHistory) in dataHistory"
              :key="`${indexHistory}-history`"
              class="row-content-table-history"
              style="border-bottom: 1px solid #e1e1e1; background: #ffffff"
            >
              <div class="data-table-history">
                <p class="averta-regular label-14 color-black has-text-centered">
                  {{
                    history.created_at
                      ? moment(history.created_at).format('dddd, DD MMMM YYYY (HH:mm)')
                      : ''
                  }}
                </p>
              </div>
              <div class="data-table-history">
                <p class="averta-regular label-14 color-black has-text-centered">
                  {{ history.user_name }}
                </p>
              </div>
              <div class="data-table-history">
                <p class="averta-regular label-14 color-black has-text-centered">
                  {{ history.source }}
                </p>
              </div>
              <div class="data-table-history-3">
                <b-tooltip
                  :label="formatDetail(history)"
                  position="is-bottom"
                  size="is-large"
                  multilined
                  append-to-body
                  type="is-black"
                >
                  <p class="averta-regular label-14 color-black has-text-centered">
                    {{ formatDetail(history) }}
                  </p>
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
        <!-- Content Table -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { ProyekEmptyIcon } from '@/components/icons'

export default {
  name: 'TabDetailHistoryWorkRestriction',
  props: {
    projectId: {
      type: Number,
      default: 0
    }
  },
  components: {
    ProyekEmptyIcon
  },
  data () {
    return {
      moment: moment,
      dataHistory: []
    }
  },
  mounted () {
    this.loadWorkRestrictionHistory()
  },
  computed: {
    dayArray () {
      return ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
    },
    sesssionArray () {
      return ['Seharian', 'Pagi', 'Sore']
    }
  },
  methods: {
    convertDate (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('dddd, DD MMMM YYYY')
    },
    convertShortDate (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD MMM YYYY')
    },
    typeHistory (val, name) {
      switch (val) {
        case 'INSERT':
          return name ? 'Baru' : 'bg-green-2'
        case 'UPDATE':
          return name ? 'Update' : 'bg-dark-yellow'
        default:
          return name || 'bg-dark-grey-4'
      }
    },
    formatDetail (dataHistory) {
      const { type, payload_old: payloadOld, payload } = dataHistory
      switch (type) {
        case 'INSERT':
          return this.formatPayloadInsert(payload)
        case 'UPDATE':
          return this.formatPayloadUpdate(payloadOld, payload)
        default:
          return this.formatPayloadUpdate(payloadOld, payload)
      }
    },
    getItemKey (item) {
      return item.type === 'DAY' ? `DAY-${item.day}` : `DATE-${item.date}`
    },
    getItemLabel (item, sesiOverride = null) {
      const sesi = sesiOverride !== null ? sesiOverride : item.sesi
      return item.type === 'DAY'
        ? `${this.dayArray[item.day]}-${this.sesssionArray[sesi]}`
        : `${this.convertShortDate(item.date)}-${this.sesssionArray[sesi]}`
    },
    formatPayloadInsert (payload) {
      return payload.map((item) => this.getItemLabel(item)).join(' · ')
    },
    formatPayloadUpdate (payloadOld, payload) {
      const list = []

      const oldMap = new Map(payloadOld.map((item) => [this.getItemKey(item), item]))
      const newMap = new Map(payload.map((item) => [this.getItemKey(item), item]))

      // Additions and edits
      for (const [key, newItem] of newMap) {
        const oldItem = oldMap.get(key)

        if (!oldItem) {
          // Key absent in old → brand new entry
          list.push(`[Baru] ${this.getItemLabel(newItem)}`)
        } else if (newItem.sesi !== oldItem.sesi) {
          // Same day/date but different session → edited entry
          list.push(`[Edit] ${this.getItemLabel(oldItem)} » ${this.sesssionArray[newItem.sesi]}`)
        }
      }

      // Deletions
      for (const [key, oldItem] of oldMap) {
        if (!newMap.has(key)) {
          list.push(`[Hapus] ${this.getItemLabel(oldItem)}`)
        }
      }

      return list.length ? list.join(' · ') : '-'
    },
    loadWorkRestrictionHistory () {
      const payload = {
        url: this.url,
        project_id: this.projectId
      }

      this.$store
        .dispatch('project/workRestrictionHistory', payload)
        .then((result) => {
          const data = result.data && result.data.data ? result.data.data : []

          if (Array.isArray(data)) {
            this.dataHistory = data
          }
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }
}
</script>

<style scoped>
.wrap-history {
  margin-bottom: 20px;
}

.card {
  background: #fafdff;
  border: 2px solid #e5e5e5;
  border-radius: 12px;
}

.wrap-header {
  border-bottom: 2px dashed #e5e5e5;
}

.wrap-status {
  border-radius: 24px;
}

.content-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100px;
  max-height: 800px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: transparent;
}

.header-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 70px;
  min-height: 70px;
  max-height: 70px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: #868686;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.body-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 70px;
  max-height: 500px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0;
  overflow: auto !important;
  background: transparent;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 1px solid #e1e1e1;
}

.body-table-history::-webkit-scrollbar {
  display: none;
}

.body-table-history {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.row-content-table-history {
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
  height: 70px;
  min-height: 70px;
  max-height: 70px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: transparent;
  gap: 5px;
}

.row-content-table-history:last-child {
  border-bottom: none !important;
}

.data-table-history {
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: transparent;
}

.data-table-history-3 {
  display: flex;
  flex: 3;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: transparent;
}

.badge-status {
  display: flex;
  flex-direction: row;
  width: auto;
  max-width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0 0.85rem;
  background: #10bd41;
  border-radius: 100px;
}
</style>
